import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Shop from './pages/Shop'
import Product from './pages/Product'
import MyOrders from './pages/Myorders'
import AdminApp from './admin/AdminApp'

export default function App() {
  return (
    <Routes>
      <Route path="admin/*" element={<AdminApp />} />

      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="shop" element={<Shop />} />
        <Route path="product/:id" element={<Product />} />
        <Route path="orders" element={<MyOrders />} />
        <Route path="*" element={<Shop />} />
      </Route>
    </Routes>
  )
}